
import httpClient from "@/plugins/axios";


export const getChangelog = async () => {
    const response = await httpClient.get(`/v1/changelog/`);
    return response;
}
